import createLucideIcon from '../createLucideIcon';

const Pencil = createLucideIcon('PencilIcon', [
  ['line', { x1: '18', y1: '2', x2: '22', y2: '6', key: '1k5sg2' }],
  ['path', { d: 'M7.5 20.5 19 9l-4-4L3.5 16.5 2 22z', key: '12iwkt' }],
]);

export default Pencil;
